import * as request from './genericRequest';

const EventsRoute = 'events';

export const getAllEvents = async () => request.getApi(EventsRoute);
export const getEventById = async (id) => request.getApi(EventsRoute, { id });
export const putEventById = async (id, isMajorUpdate, event) => request.putApi(EventsRoute, event, { id, isMajorUpdate });
export const postEvent = async (event) => request.postApi(EventsRoute, event);
export const deleteEventById = async (id) => request.deleteApi(EventsRoute, { id });
